// 팩트배치 운영 개요 표시용 한국어 라벨 맵.
// 관례(EvalPrompt/prompt-labels.js): 코드 → 한국어 맵 + `MAP[v] || v || '-'` 폴백 헬퍼.
// - 상태(status)는 고정 enum 이라 한국어만 노출.
// - error_type 는 백엔드에서 개방형 문자열로 확장될 수 있어(신규 사유 추가 가능)
//   미매핑 값은 원문 코드를 그대로 폴백으로 노출한다(정보 손실 방지).

const FACT_STATUS_LABELS = {
    queued: '대기 중',
    preparing: '준비 중',
    prepared: '준비 완료',
    running: '처리 중',
    in_batch: '배치 처리 중',
    done: '완료',
    failed: '실패',
    superseded: '대체됨',
};

// 알려진 error_type → 한국어 설명. 미매핑 값은 원문 코드로 폴백.
const FACT_ERROR_TYPE_LABELS = {
    extraction_failed: '추출 실패',
    extract_fallback: '추출 폴백 처리',
    dispatch_failed: '작업 발행 실패',
    provider_timeout: '공급자 응답 시간 초과',
    no_convertible_files: '변환 가능한 파일 없음',
    fallback_conversion_unavailable: '폴백 변환 불가',
    submit_uncertain: '제출 불확실(재제출 보류)',
    unsupported_file: '미지원 파일 형식',
    batch_line_error: '배치 응답 라인 오류',
    batch_line_missing: '배치 응답 누락',
    batch_line_mutually_exclusive_parameters: '배치 요청 파라미터 충돌',
    stale_timeout: '응답 없음(오래된 처리 중)',
    unknown: '알 수 없음',
};

const factStatusLabel = (value) => FACT_STATUS_LABELS[value] || value || '-';
const factErrorTypeLabel = (value) => FACT_ERROR_TYPE_LABELS[value] || value || '-';

export {
    FACT_STATUS_LABELS,
    FACT_ERROR_TYPE_LABELS,
    factStatusLabel,
    factErrorTypeLabel,
};
